import { render, staticRenderFns } from "./CommonSendCode.vue?vue&type=template&id=40e63e90&scoped=true&"
import script from "./CommonSendCode.vue?vue&type=script&lang=js&"
export * from "./CommonSendCode.vue?vue&type=script&lang=js&"
import style0 from "./CommonSendCode.vue?vue&type=style&index=0&id=40e63e90&lang=scss&scoped=true&"
import style1 from "./CommonSendCode.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e63e90",
  null
  
)

export default component.exports